import { useQuery } from '@apollo/client/react';
import { useCompanyFeatures } from 'app/domains/companies';
import { MatchWorkflowsForDocumentDocument } from './MatchWorkflowsForDocument.gql';
import { MatchedWorkflowsDocument } from './MatchedWorkflows.gql';
export const useMatchWorkflowsForDocument = (documentId, types) => {
    const { isFeatureAvailable } = useCompanyFeatures();
    const isWorkflowsBetaAvailable = isFeatureAvailable('document-assistant:workflows');
    const { data, loading, error } = useQuery(MatchWorkflowsForDocumentDocument, {
        variables: { documentId },
        skip: !isWorkflowsBetaAvailable,
        fetchPolicy: 'network-only',
    });
    const results = (data === null || data === void 0 ? void 0 : data.matchWorkflows) || [];
    const workflowIds = results
        .filter((result) => types.includes(result.workflowType))
        .map((result) => result.workflowId);
    const { data: workflowsData, loading: workflowsLoading, error: workflowsError, } = useQuery(MatchedWorkflowsDocument, {
        variables: { workflowIds, types },
        skip: workflowIds.length === 0 || !isWorkflowsBetaAvailable,
        fetchPolicy: 'network-only',
    });
    const allWorkflows = (workflowsData === null || workflowsData === void 0 ? void 0 : workflowsData.workflows) || [];
    const matchedWorkflows = allWorkflows
        .filter((w) => workflowIds.includes(w.id))
        .map((w) => {
        var _a;
        return ({
            id: w.id,
            type: w.type,
            name: ((_a = w.versions[0]) === null || _a === void 0 ? void 0 : _a.name) || w.id,
        });
    });
    return {
        loading: loading || workflowsLoading,
        error: workflowsError || error,
        matchedWorkflows,
        hasMatches: matchedWorkflows.length > 0,
    };
};
